import React, { useState, useReducer } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl } from '../../lib/ep.js';

import ActionButton, { SecondaryButton, SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import { DeleteButton } from '../builder/ConfirmButton.js';
import SearchField from '../builder/SearchField';
import Spinner from '../builder/Spinner';

import PhotoEmbed from '../front/PhotoEmbed';

import SingleGallery from '../front/SingleGallery';

import { useFilterDataQuery, usePaginator, operators } from '../FilterContent';
import { useCSS } from '../../lib/hooks.js';
import Module from '../ui_items/Module.js';
import Tooltip from '../builder/Tooltip.js';
import ActionLink from '../builder/ActionLink.js';

const VotingCandidateManager = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const stage = (props.stage != undefined) ? props.stage : false;
	const promotion = (props.promotion != undefined) ? props.promotion : false;
	
	if(!stage) return null;

	useCSS('comp/owner_multigallery.css');
	useCSS('comp/multigallery.css');

	const items_per_page = 12;

	const getUsers = (start = false, limit = 100) => {
		if(limit == 100) setLoading(true);

		let url = `/stages/getvotingcandidates/${stage.promotion_id}/${stage.id}`;
		return $.getJSON(getRemotedbUrl(url), { start, limit }, (res) => {
			setLoading(false);
		});
	}

	const [ galleryState, dispatchGallery ] = useReducer((state, action) => {
		switch(action.type) {
			case 'OPEN_ENTRY':
				return { ...state, current_participation:action.participation, current_media:action.media_index };

			case 'CLOSE_ENTRY':
				return { ...state, current_participation:false, current_media:0 };

			default:
				return state;
		}
	}, {
		current_media:0,
		current_participation:false,
	});

	const [ loading, setLoading ] = useState(false);
	const [ search, setSearch ] = useState("");
	const [ state, dispatch, fetchAll ] = useFilterDataQuery('media', getUsers, {
		indexer:(indexed, element) => {},
		limit:items_per_page,
		pagination:500,
		fetch_all_disabled:false,
		items_per_page:items_per_page,
	});

	const [ data, pagination, goToPage ] = usePaginator(state.filtered, items_per_page, {
		limit:galleryState.limit,
		reset_page_on_items_length:true,
	});

	const openEntryAsLayer = (participation, media_index) => {
		dispatchGallery({
			type:'OPEN_ENTRY',
			participation,
			media_index,
		});
	};

	const closeEntryAsLayer = () => {
		dispatchGallery({ type:'CLOSE_ENTRY' });
	};

	const searchEntries = (k, value) => {
		const filter = {
			key:'search',
			name:"Name",
			tier1:['Participation.search_media_values'],
			tier2:{...operators.textOperators},
			tier3:'input',
			type:'string',
		};

		dispatch({
			type:'SETFILTER',
			filter:{
				key:'search',
				value,
				operator:'like_all',
				filter,
			},
			unique:true,
		});

		setSearch(value);
	};

	if(loading) {
		return (
			<Module>
				<Spinner autotranslate={false}>{i18n("Loading the gallery")}...</Spinner>
			</Module>
		)
	}

	const deleteCandidate = (user) => {
		$.post(getRemotedbUrl(`/stages/delete_voting_candidate/${promotion.id}/${stage.id}`), { id:user.StageVote.id });
		dispatch({
			type:'REMOVE_ENTRY',
			uid:user.Participation.id,
		});
	}

	const getResponsiveImageUrl = (file, size) => {
		const type_media = (file.type != undefined) ? file.type : 'image';
		if(size == undefined) size = 'normal';

		let thumbnail;
		let size_thumb;
		switch(type_media) {
			case 'video':
			case 'vimeo':
				switch(size) {
					case 'big':
						size_thumb = '1920x1080';
						break;

					case 'thumb':
						size_thumb = '360x640';
						break;

					case 'normal':
					default:
						size_thumb = '1280x720';
						break;
				}
				thumbnail = `${file.full_path}${file.filename}_${size_thumb}?r=pad`;
				break;

			case 'youtube':
				switch(size) {
					case 'big':
						size_thumb = 'maxresdefault';
						break;

					case 'thumb':
						size_thumb = 'sddefault';
						break;

					case 'normal':
					default:
						size_thumb = 'hqdefault';
						break;
				}
				thumbnail = `${file.full_path}${file.filename}/${size_thumb}.jpg`;
				break;

			case 'image':
			default:
				thumbnail = `${file.full_path}${size}/${file.filename}`;
				break;
		}

		return thumbnail;
	};

	let totals = state.total;

	return (
		<section class="gui_users_registered full_height_flexed without_actions">
			<Module>
				<div class="candidates_picker">
					<div class="candidates_list">
						<div>
							<ul class="multigallery_tool simple_registered_entries_list in_layer visible_overflowed_container wt_bg">
								<li class="list_header single_item">
									<div class="tabled_item">
										<span class="user_name gui_flex_row" style={{alignItems:'baseline'}}>
											<strong style={{flexGrow:'1'}}>{i18n("Total")}: {totals}</strong>
										</span>
									</div>
								</li>

								{(data.length > 0) ? (
									data.map((_user) => {
										if(_user.Participation == undefined) return null;   // PARCHE per evitar error quan s'arriba des d'Audience > Tools > Gallery
										const participation = _user.Participation;
										const album_title = (participation.quiz_entry.title != undefined && participation.quiz_entry.title != "") ? participation.quiz_entry.title : false;
										const media = (participation.quiz_entry != undefined) ? participation.quiz_entry.media : [];
										const gallery_count = media.length;
										const is_selected = (galleryState.current_participation !== false && participation.id == galleryState.current_participation.id) ? true : false;

										return (
											<li key={participation.id} class="single_item">
												<div class="tabled_item static_entry_info">
													<span class="user_name">
														<strong class="blueColor">{participation.name}</strong>

														{(_user.StageVote != undefined) && (
															<span>Votes: {_user.StageVote.points}</span>
														)}

														{(album_title != false) &&(
															<span class="album_title" dangerouslySetInnerHTML={{ __html:'<span>' + i18n("Album") + ':</span> ' + album_title.replace(/\n/g, '<br />') }} />
														)}
													</span>

													<span class="displaced" style={{flexBasis:'150px'}}>{EPDateFormat(participation.created, 'L, LT')} h</span>

													<ButtonCollection style={{flexBasis:'30px'}}>
														<DeleteButton
															squared={true}
															onClick={() => deleteCandidate(_user)}
														/>
													</ButtonCollection>
												</div>

												<div class="album">
													{(gallery_count > 0) && (
														<ul class="medias">
															{media.map((element, m) => {
																element.thumbnail = getResponsiveImageUrl(element, 'normal');

																return (
																	<li key={m} onClick={() => openEntryAsLayer(participation, m)}>
																		<PhotoEmbed file={element} type="normal" adapt="height" />
																	</li>
																)
															})}
														</ul>
													)}
												</div>

												{(is_selected && galleryState.current_participation !== false && galleryState.current_participation.id == participation.id) && (
													<ul class="gui_multimedia_gallery">
														<SingleGallery
															closeLayer={closeEntryAsLayer}
															current_media={galleryState.current_media}
															media={media}
															user={_user}
															stage={stage}
															selected_entry={true}
															promotion={promotion}
															in_registered={true}
															is_builder={true}
														/>
													</ul>
												)}
											</li>
										)})
								) : (
									<li>{i18n("There are no results.")}</li>
								)}
							</ul>

							{(pagination.total_pages > 0) && (
								<div class="gui_paginator" style={{marginTop:'2em'}}>
									<ul>
										<li class={(pagination.page == 1) ? 'disabled' : null}>
											<SquaredButton
												icon='knk-arrow-l-big'
												color={(pagination.page == 1) ? 'black' : 'blue'}
												_class={{other:'gui_small_icon go_prev_page not_bordered_button'}}
												onClick={() => goToPage((pagination.page > 1) ? (pagination.page -1) : 1)}
												tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("previous", 'ucfirst')}</Tooltip>}
												aria-label="Go to previous page"
											/>
										</li>
			
										{pagination.pages_arr.map((page, p) => {
											const selected = (page == pagination.page) ? true : false;
											let page_label = page;
											if(pagination.total_pages > 10) {
												if(parseInt(page_label) < 10) page_label = `0${page_label}`;
												if(pagination.total_pages > 100) {
													if(parseInt(page_label) < 100) page_label = `0${page_label}`;
													if(pagination.total_pages > 1000) {
														if(parseInt(page_label) < 1000) page_label = `0${page_label}`;
													}
												}
											}
			
											return (
												<li key={p} class={'page_number' + ((selected) ? ' selected' : '')}>
													<ActionLink
														onClick={() => goToPage(page)}
														autotranslate={false}
													>{page_label}</ActionLink>
												</li>
											)
										})}
			
										<li class={(pagination.page == pagination.total_pages) ? 'disabled' : null}>
											<SquaredButton
												color={(pagination.page < pagination.total_pages) ? 'black' : 'blue'}
												icon='knk-arrow-r-big'
												_class={{ other:'gui_small_icon go_next_page not_bordered_button' }}
												onClick={() => goToPage((pagination.page < pagination.total_pages) ? (pagination.page + 1) : pagination.total_pages)}
												tooltip={<Tooltip with_icon={false} autotranslate={false} position="top">{i18n("next", 'ucfirst')}</Tooltip>}
												aria-label="Go to next page"
											/>
										</li>
									</ul>
								</div>
							)}
						</div>
					</div>

					<aside class="selected_entries">
						<SearchField change={searchEntries} _class={{first:true}} name="search" value={search} _placeholder="Search by name" />

						<ButtonCollection _class={{other:'not_in_top'}}>
							<SecondaryButton
								onClick={() => props.backButton()}
							>Close layer</SecondaryButton>
						</ButtonCollection>
					</aside>
				</div>
			</Module>
		</section>
	);
}

export default injectIntl(VotingCandidateManager);